<!--
* @name：视频直传OSS组件
* @author：Jeff Guo
-->
<template>
    <div class="upload-file-box">
        <div class="upload-file-content">
            <div class="upload-file-button-box">
                <el-upload
                    ref="upload"
                    class="upload-video"
                    action="/"
                    name="name"
                    :accept="fileType.join(',')"
                    :on-remove="remove"
                    :limit="limit"
                    :multiple="multiple"
                    :before-upload="beforeAvatarUpload"
                    :http-request="upLoad"
                    :auto-upload="autoUpload"
                    :disabled="isUpload"
                    :style="{ justifyContent: buttonCenter ? 'center' : 'flex-start' }"
                    :show-file-list="false"
                    :on-exceed="handleExceed"
                >
                    <el-button
                        slot="trigger"
                        :disabled="isUpload"
                        size="small"
                        :type="disType"
                        :loading="isLoading.type === 1 ? isLoading.loading : loading"
                        :style="{fontSize: fontSize + 'px'}"
                    >{{ buttonText }}</el-button>
                    <span slot="tip" v-if="tips" class="tips">{{ tips }}</span>
                </el-upload>
                <div v-if="isShowName">{{ name }}</div>
            </div>

            <ul v-if="isShowFile && uploadFileList.length" class="upload-file-list">
                <li v-for="(item, index) in uploadFileList" :key="index" class="upload-file-list-li">
                    <span class="upload-file-list-name" @click="onPreview(item,index)">{{ item.fileName }}</span>
                    <img v-if="limit !== 1" src="@/assets/img/3.png" @click="onDelete(item, index)" />
                </li>
            </ul>
        </div>

        <span v-if="placeholder" style="color:#ccc">{{ placeholder }}</span>
    </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
import { fileService } from '../../utils/file-service'
import { FileService } from '@galaxy-fe/utils';

export default {
    name: 'UploadFile',
    props: {
        value: {
            type: String,
            default: ''
        },
        /*
        设置OSS文件ALC读写权限，缺省公共读
        private: 私有   ['private', 'public-read', 'default']
        public-read： 公共读
        default: 继承bucket权限
        */
        acl: {
            type: String,
            default: 'private',
        },
        // 上传的列表,用于详情显示
        fileList: {
            type: Array,
            default: () => []
        },
        fileListName: {
            type: String,
            default: 'name'
        },
        fileListUrl: {
            type: String,
            default: 'path'
        },
        disType: {
            type: String,
            default: 'primary'
        },
        // 是否自动上传
        autoUpload: {
            type: Boolean,
            default: true
        },
        // 限制文件大小 单位 mb
        maxSize: {
            type: Number,
            default: () => {
                return 20
            }
        },
        // 开启图片压缩阈值 单位 mb
        minCompressSize: {
            type: Number,
            default: () => {
                return 4
            }
        },
        // 允许上传的文件格式  参考 https://www.bluestep.cc/html5-file%E8%A1%A8%E5%8D%95accept%E7%9A%84%E7%A7%8D%E7%B1%BB%E6%B1%87%E6%80%BB/
        fileType: {
            type: Array,
            default: () => {
                return ['images/png', 'images/jpeg', 'images/bmp']
            }
        },
        // 允许上传的文件数量
        limit: {
            type: Number,
            default: () => {
                return 1
            }
        },
        // 上传按钮显示文字
        buttonText: {
            type: String,
            default: '上传文件'
        },
        // 上传按钮居中
        buttonCenter: {
            type: Boolean,
            default: false
        },
        // 上传文字大小
        fontSize: {
            type: String,
            default: '12'
        },
        // 提示
        tips: {
            type: String,
            default: ''
        },
        // 文件大小（返回用）
        size: {
            type: Number,
            default: () => {
                return 0
            }
        },
        // 文件名称（返回用）
        name: {
            type: String,
            default: ''
        },
        // 文件类型（返回用）
        type: {
            type: String,
            default: ''
        },
        // 是否展示文件名
        isShowName: {
            type: Boolean,
            default: false
        },
        // 是否显示上传文件
        isShowFile: {
            type: Boolean,
            default: false
        },
        // 提示支持格式文字
        placeholder: {
            type: String,
            default: ''
        },
        formatTip: {
            type: Array,
            default: () => [] //'png', 'jeg', 'bmp'
        },
        isUpload: {
            type: Boolean,
            default: false
        },
        // 上传提示语
        sucTips: {
            type: String,
            default: () => '上传成功！'
        },
        // 是否要提示语
        isSucTips: {
            type: Boolean,
            default: () => true
        },
        // loading是否外部控制, 使用:isLoading.sync="{}"修饰符
        isLoading: {
            type: Object,
            default: () => {
                return {
                    loading: false,
                    type: 0 // 0 不需要，1 是需要
                }
            }
        },
        // 是否可以选择多张
        multiple: {
            type: Boolean,
            default: () => false
        },
        // 文件名称
        fileNames: {
            type: String,
            default: ''
        },
        // 上传成功是否需要组件内的成功提示
        needSuccess: {
            type: Boolean,
            default: true
        },
        // 父组件当条数据的下标
        idx: {
            type: Number,
            default: () => {
                return 0
            }
        },
    },
    data() {
        return {
            loading: false,
            disabled: false,
            uploadFileList: []
        }
    },
    watch: {
        fileList() {
            this.conversion()
        }
    },
    created() {
        this.conversion()
    },
    methods: {
        //显示上传处理
        conversion() {
            if (!this.fileList || !this.fileList.length) return (this.uploadFileList = [])
            this.uploadFileList = this.fileList.map(item => {
                return {
                    fileName: item[this.fileListName],
                    fileUrl: item[this.fileListUrl]
                }
            })
        },
        // 预览文件
        async onPreview(item, index) {
            let url = item.fileUrl
            const ext = FileService.getFileExtension(url)
            if(FileService.isImage(url) || ext === 'pdf') {
                window.open(fileService.getOssFilePublicUrlSync(url))
            }else {
                window.open(
                    await this.$utils.previewUrl(item.fileUrl, item.fileName),
                    "_blank"
                );
            }
        },
        // 删除文件
        async onDelete(item, index) {
            this.uploadFileList.splice(index, 1)
            this.$emit('fileList', this.uploadFileList, this.idx)
        },

        // 删除文件
        remove(file, fileList) {
            this.$emit('input', '')
            this.$emit('fileList', this.uploadFileList)
            // this.$refs.upload.clearFiles()
        },

        beforeAvatarUpload(file) {
            if (file.size === 0) {
                this.$refs.upload.clearFiles()
                return this.$message.warning('请不要上传空文件！')
            }
            let isType = true
            let suffix = file.name.split('.')
            if (this.formatTip && this.formatTip.length && this.formatTip.indexOf(suffix[suffix.length - 1]) < 0) {
                isType = false
            }

            // const fileLimit = this.uploadFileList.length < this.limit
            // if(!fileLimit) {
            //     this.$message.warning(`附件上限为 ${this.limit}个文件!`)
            //     return false
            // }

            const isLtSize = file.size / 1024 / 1024 < this.maxSize
            if (!isType) {
                this.$message.warning('上传格式须为' + this.formatTip.join('、') + '的格式')
                return false
            }
            if (!isLtSize) {
                this.$message.warning(`上传文件大小不能超过 ${this.maxSize}mb!`)
                return false
            }
            // return isType && isLtSize && fileLimit
        },

        // 执行上传
        async upLoad(res) {
            try {
              if (res.file.size === 0) {
                  this.$refs.upload.clearFiles()
                  return this.$message.warning('请不要上传空文件！')
              }
              if (this.isLoading.type === 1) {
                  this.$emit('update:isLoading', {
                      loading: true,
                      type: 1
                  })
              } else {
                  this.loading = true
              }
              // this.loading = true
              let pos = res.file.name.lastIndexOf('.') // 扩展名
              let fileExten = res.file.name.substring(pos, res.file.name.length) // 文件名称 不含扩展名
              let storeAs = `crm/${process.env.VUE_APP_ENV}/files/${this.fileNames}${new Date().getTime()}${fileExten}` //文件存储路径 路径文件可自定义
              let uploadFile = res.file
              // 如果图片大于4mb则开启压缩图片
              if (res.file.type.startsWith('image') && res.file.size / 1024 / 1024 > this.minCompressSize) {
                  uploadFile = await imageConversion.compressAccurately(res.file, 4000)
              }

              await this.multipartUploadApi(storeAs, uploadFile)
            } catch (err) {
              console.error(err)
            } finally {
              this.loading = false
            }
        },
        getFileNameFromUrl(url) {
            // 创建一个新的URL对象
            const urlObj = new URL(url);
            // 获取pathname部分
            const pathname = urlObj.pathname;
            // 通过'/'分割pathname，取最后一部分作为文件名
            const fileName = pathname.split('/').pop();
            return fileName;
        },
        multipartUploadApi(storeAs, file) {
            // this.$OSS
            //     .multipartUpload(storeAs, file)
            return fileService.privateUploadFile(file)
                .then((file_url) => {
                    let uploadFileArr = JSON.parse(JSON.stringify(this.uploadFileList))
                    if (this.isLoading.type === 0) {
                        this.loading = false
                    }
                    let res = {
                        name: this.getFileNameFromUrl(file_url),
                    }
                    // this.loading = false
                    if ('name' in res) {
                        // let url = `${this.$CONFIG.OSS_BASE_URL}${res.name}`
                        let url = file_url
                        if (this.limit === 1) {
                            this.uploadFileList = [{ fileName: file.name, fileUrl: url, fileSize: file.size }]
                        } else {
                            if (uploadFileArr.length > 0) {
                                let repet = false; // 是否有相同的
                                for (let i = 0; i < uploadFileArr.length; i++) {
                                    if (this.uploadFileList[i].fileName === file.name) {
                                        this.uploadFileList[i] = { fileName: file.name, fileUrl: url, fileSize: file.size }
                                        repet = true;
                                    }
                                }
                                if (!repet) {
                                    this.uploadFileList.push({ fileName: file.name, fileUrl: url, fileSize: file.size })
                                }
                            } else {
                                this.uploadFileList.push({ fileName: file.name, fileUrl: url, fileSize: file.size })
                            }
                        }
                        console.log(this.uploadFileList)
                        this.$emit('fileList', this.uploadFileList, this.idx)

                        // this.$emit('input', `${this.$CONFIG.OSS_BASE_URL}${res.name}`)
                        this.$emit('input', url)
                        this.$emit('update:size', file.size)
                        this.$emit('update:name', file.name)
                        this.$emit('update:type', file.type)
                        if (this.isSucTips && this.needSuccess) {
                            this.$message.success(this.sucTips)
                        }
                        this.$refs.upload.clearFiles()
                        // if (this.acl !== 'public-read') this.$OSS.putACL(storeAs, this.acl)
                    } else {
                        this.$emit('input', '')
                    }
                })
                .catch(err => {
                    // 上传失败也要清除loading
                    if (this.isLoading.type === 0) {
                        this.loading = false
                    } else {
                        this.$emit('update:isLoading', {
                            type: 1,
                            loading: false
                        })
                    }
                    this.$message.error('上传失败！')
                })
        },
        handleExceed(files) {
            if (this.uploadFileList.length + files.length > this.limit) {
                return this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + this.uploadFileList.length} 个文件`);
            }
        },
    }
}
</script>
<style lang="less" scope>
.upload-video {
    display: flex;
    // justify-content: center;
    align-items: center;
    > .tips {
        padding-left: 8px;
        color: #e6a23c;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        text-align: center;
    }
    .avatar {
        display: block;
    }
    .msg {
        color: #ff5e00;
    }
}

// .upload-file-button-box {
//     // display: inline-block;
// }

.upload-file-list {
    display: inline-block;
    .upload-file-list-li {
        display: inline-block;
        padding-right: 10px;
        margin-top: 5px;
        .upload-file-list-name {
            cursor: pointer;
            color: #409eff;
            padding-right: 5px;
        }
    }
}
</style>
